export default __webpack_public_path__ + "static/media/CeskyKrumlov_sm.1d6e98d1.jpg";